"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PropertyInputMultiCurrencyCurrencyCode = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _ResolveReferences = _interopRequireDefault(require("reference-resolvers/ResolveReferences"));

var _ProvideReferenceResolvers = _interopRequireDefault(require("reference-resolvers/ProvideReferenceResolvers"));

var _MultiCurrencyInformationResolver = _interopRequireDefault(require("reference-resolvers/resolvers/MultiCurrencyInformationResolver"));

var _ReferenceObjectTypes = _interopRequireDefault(require("reference-resolvers/constants/ReferenceObjectTypes"));

var _CurrencySelect = _interopRequireDefault(require("ui-addon-i18n/components/CurrencySelect"));

var _immutable = require("immutable");

var _utils = require("reference-resolvers/utils");

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var getCurrencyCode = function getCurrencyCode(record) {
  return record.id;
};

var getIsCurrencyVisible = function getIsCurrencyVisible(record) {
  return (0, _getIn.default)(['referencedObject', 'visible'], record) === true;
};

var PropertyInputMultiCurrencyCurrencyCode =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PropertyInputMultiCurrencyCurrencyCode, _Component);

  function PropertyInputMultiCurrencyCurrencyCode() {
    (0, _classCallCheck2.default)(this, PropertyInputMultiCurrencyCurrencyCode);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputMultiCurrencyCurrencyCode).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputMultiCurrencyCurrencyCode, [{
    key: "focus",
    value: function focus() {
      return this.refs.input.focus();
    }
  }, {
    key: "getCurrencies",
    value: function getCurrencies() {
      var currencyCodes = this.props.currencyCodes;

      if ((0, _utils.isResolved)(currencyCodes)) {
        return (0, _immutable.List)(currencyCodes);
      }

      return (0, _immutable.List)();
    }
  }, {
    key: "getPossibleCurrencies",
    value: function getPossibleCurrencies() {
      var _this = this;

      var currencies = this.getCurrencies();
      return currencies.filter(function (currency) {
        return getIsCurrencyVisible(currency) || getCurrencyCode(currency) === _this.props.value;
      }).map(getCurrencyCode);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          currencyCodes = _this$props.currencyCodes,
          onChange = _this$props.onChange,
          value = _this$props.value;
      var possibleCurrencies = this.getPossibleCurrencies(currencyCodes);
      var displayValue = value ? value.toString() : undefined;
      return _react.default.createElement(_CurrencySelect.default, {
        className: className,
        currenciesFilter: function currenciesFilter(currencyOption) {
          return possibleCurrencies.includes(currencyOption.value);
        },
        currencyStyle: "long",
        onChange: onChange,
        ref: "input",
        value: displayValue,
        "data-selenium-test": this.props['data-selenium-test']
      });
    }
  }]);
  return PropertyInputMultiCurrencyCurrencyCode;
}(_react.Component);

exports.PropertyInputMultiCurrencyCurrencyCode = PropertyInputMultiCurrencyCurrencyCode;
PropertyInputMultiCurrencyCurrencyCode.propTypes = {
  className: _react.PropTypes.string,
  currencyCodes: _react.PropTypes.instanceOf(_immutable.Seq),
  onChange: _react.PropTypes.func.isRequired,
  value: _react.PropTypes.string,
  'data-selenium-test': _react.PropTypes.string
};
var getCurrencyCodes = (0, _ResolveReferences.default)(function (resolvers) {
  return {
    currencyCodes: resolvers[_ReferenceObjectTypes.default.MULTI_CURRENCY_INFORMATION].all()
  };
});

var _default = (0, _ProvideReferenceResolvers.default)((0, _defineProperty2.default)({}, _ReferenceObjectTypes.default.MULTI_CURRENCY_INFORMATION, _MultiCurrencyInformationResolver.default), getCurrencyCodes(PropertyInputMultiCurrencyCurrencyCode, {
  forwardRef: true
}), {
  forwardRef: true,
  mergeResolvers: true
});

exports.default = _default;